<template>
  <v-card v-if="driver">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Insurance") }}</h3>
    </v-btn>
    <v-btn
      color="blue"
      style="float: right"
      x-small
      class="tariff-right-headers"
      target="_blank"
      href="/expense/create?accountCode=DriverExpense&expenseType=Insurance"
    >
      + {{ $i18n.t("Add") }}
    </v-btn>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Insurance No.") }} :
        {{ driver.driverDetail.insurance.insuranceNo }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="3"
        >{{ $i18n.t("Start Date") }} :
        {{ formatDate(driver.driverDetail.insurance.startDate) }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="3"
        >{{ $i18n.t("Expiry") }} :
        {{ formatDate(driver.driverDetail.insurance.insuranceExpiry) }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="2"
        >{{ $i18n.t("Amount") }} :
        {{ driver.driverDetail.insurance.currency }}
        {{ driver.driverDetail.insurance.amount }}</v-col
      >

      <v-col cols="12" sm="12" md="12" lg="12"
        >{{ $i18n.t("Insurance Company") }} :
        {{ driver.driverDetail.insurance.insuranceCompany }}</v-col
      >

      <v-col cols="12" sm="11" md="11" lg="11"
        >{{ $i18n.t("Details") }} :
        {{ driver.driverDetail.insurance.detail }}</v-col
      >

      <v-col cols="12" sm="1" md="1" lg="1">
        <a
          v-if="driver.driverDetail.insurance.expense_id"
          :href="'/expense/' + driver.driverDetail.insurance.expense_id"
          target="_blank"
        >
          <v-icon>mdi-pencil</v-icon>
        </a>
      </v-col>
    </v-row>
    <expenses :expenseType="'Insurance'" :entity_id="driver._id" />
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import Expenses from "@/views/driver/Expenses.vue";
import common from "@/store/common/module/common";

@Component({
  name: "Insurance",
  props: {
    value: {
      default: null,
    },
  },
  components: {
    Expenses,
  },
})
export default class Insurance extends Vue {
  driver = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.driver = newVal;
  }

  async mounted() {
    if (this.value) this.driver = this.value;

    if (!this.driver) this.driver = {};
    if (!this.driver.driverDetail) this.driver.driverDetail = {};
    if (!this.driver.driverDetail.insurance)
      this.driver.driverDetail.insurance = {};
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>